<script>

import ParcelInfoForm from "@/components/common/modal/ParcelInfoForm.vue"
import { ref } from 'vue'

export default {
  name: "Parcel-list",
  components: {
    ParcelInfoForm,
  },
  watch: {
    "$store.getters.getParcelList"(val) {
      this.parcelList = val
    },
  },
  data() {
    return {
      columns : [
        { name: 'hblNo', label: 'H/BL No.', align: 'center', field: 'hblNo' },
        { name: 'partnerName', label: '파트너명', align: 'center', field: 'partnerName' },
        { name: 'statusName', label: '진행상태', align: 'center', field: 'statusName' },
        { name: 'receiverName', label: '받는 사람', align: 'center', field: 'receiverName' },
        { name: 'receiverMobile', label: '전화번호', align: 'center', field: 'receiverMobile' },
        { name: 'regDate', label: '등록일', align: 'center', field: 'regDate' },
      ],
      modifyModalShow : false,
      selectedParcel  : ref([]),
      userType        : 'cus',
      pagination      : ref({
        rowsPerPage: 10
      }),
      parcelList      : this.$store.getters.getParcelList,
    }
  },
  methods:{
    statusColor(statusName = '') {
      const text = String(statusName || '')
      if (text.includes('완료') || text.includes('반출') || text.includes('배송')) return 'positive'
      if (text.includes('출항') || text.includes('대기') || text.includes('접수')) return 'primary'
      if (text.includes('보류') || text.includes('지연')) return 'warning'
      if (text.includes('취소') || text.includes('삭제') || text.includes('오류')) return 'negative'
      return 'grey-7'
    },
    // 배송상품 상세보기 by Admin
    modalParcelDetail(id) {
      // this.$log.debug("[ Axios / 배송상품 상세버튼 클릭 ]", id)
      this.modifyModalShow  = !this.modifyModalShow 
      let t = this.parcelList.filter(item => {
        // this.$log.debug("[ Axios / 배송상품 상세버튼 클릭 ] item.id = ", item.id)
        if(item.id == id){ return item }
      })
      this.selectedParcel = t
    },
    // 모달 닫기
    closeModal(){
      this.modifyModalShow = false
    }
  }
}
</script>

<template>

  <q-table
    class="my-sticky-virtscroll-table"
    virtual-scroll
    v-model:pagination="pagination"
    :rows-per-page-options="[0]"
    :virtual-scroll-sticky-size-start="48"
    row-key="index"
    :rows="parcelList"
    :columns="columns">

    <template #body-cell-statusName="props">
      <q-td :props="props">
        <q-badge
          :color="statusColor(props.row.statusName)"
          :label="props.row.statusName || '-'" />
      </q-td>
    </template>
    
  </q-table>
  
  <teleport to="body">
    <q-dialog 
      v-model="modifyModalShow">

      <ParcelInfoForm
        :selectedParcel="selectedParcel"
        :user="userType"
        />

    </q-dialog>
  </teleport>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
